// Custom field columns need the list feature AND the Custom Fields module - the same module check the
// record page uses (Util.hasCustomFields). Off means the query selects no custom field data at all and
// the picker has no CUSTOM FIELDS section.
import {hasFeatureFlag} from '../../util/FeatureUtil';
import Util from '../../util/util';
import {FEATURE_FLAGS} from '../../../../constants';

export const shouldLoadCustomFieldColumns = (): boolean =>
	hasFeatureFlag(FEATURE_FLAGS.CUSTOM_FIELDS_LISTS) && Util.hasCustomFields();
